@import "../../../node_modules/photoswipe/dist/photoswipe.css";
@import "../../../node_modules/photoswipe-dynamic-caption-plugin/photoswipe-dynamic-caption-plugin.css";

stzh-gallery {
  @include host;
  overflow-x: hidden;
}

.stzh-gallery {
  &__carousel-actions,
  &__actions {
    transition: opacity 0.1s linear;
  }

  &__carousel-actions.is-hidden-during-animation,
  &__slide.is-hidden-during-animation &__actions {
    opacity: 0;
  }

  &__actions {
    padding: space("xsmall");
  }

  &__list {
    @include spaceCurve("row-gap", "large");
    display: grid;
    column-gap: $gridGutter;

    @include mq($from: small) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      column-gap: $gridGutterSmall;
    }

    @include mq($from: medium) {
      grid-template-columns: repeat(3, minmax(0, 1fr));
      column-gap: $gridGutterMedium;
    }

    @include mq($from: large) {
      column-gap: $gridGutterLarge;
    }

    @include mq($from: ultra) {
      column-gap: $gridGutterUltra;
    }
  }

  &__list-actions {
    @include spaceCurve("margin-top", "large");
    display: grid;

    @include mq($from: small) {
      justify-content: center;
    }
  }

  /* Lightbox elements */

  &__pswp {
    @include font;
    --pswp-bg: #{$colorWhite};
  }

  &__pswp .pswp__icn {
    fill: $colorPrimary;
  }

  &__pswp .pswp__top-bar {
    align-items: flex-start;
  }

  &__pswp .pswp__button {
    opacity: 1;
    width: 44px;
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: $colorPrimary70;
    background-color: $colorSecondary30;
    border: none;
    border-radius: $buttonBorderRadius;
    transition-duration: $baseTransitionAnimationSpeed;
    transition-property: color, background-color, border-color, opacity;

    @media print {
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }

    @include mq($from: large) {
      width: 56px;
      height: 56px;
    }

    &:hover {
      color: $colorPrimary80;
      background-color: $colorSecondary40;
    }

    svg {
      width: iconSize();
      height: iconSize();

      @include mq($from: large) {
        width: iconSize("large");
        height: iconSize("large");
      }
    }

    &--close {
      @include spaceCurve("margin-top", "regular");
      @include spaceCurve("margin-right", "regular");
      width: 56px;
      height: 56px;
      color: $colorPrimary70;
      background-color: transparent;

      &:hover {
        color: $colorPrimary80;
        background-color: $colorSecondary20;
      }

      svg {
        width: iconSize("large");
        height: iconSize("large");
      }
    }

    &[disabled] {
      color: $colorGrey80;
      background-color: $colorGrey20;
    }

    &--arrow {
      // width: auto;
      // height: auto;
      margin-top: -20px;
    }

    &--arrow--prev {
      left: space("xsmall");

      @include mq($from: small) {
        left: $containerMarginSmall;
      }

      @include mq($from: medium) {
        left: $containerMarginMedium;
      }

      @include mq($from: large) {
        left: $containerMarginLarge;
      }

      @include mq($from: ultra) {
        left: 126px;
      }
    }

    &--arrow--next {
      right: space("xsmall");

      @include mq($from: small) {
        right: $containerMarginSmall;
      }

      @include mq($from: medium) {
        right: $containerMarginMedium;
      }

      @include mq($from: large) {
        right: $containerMarginLarge;
      }

      @include mq($from: ultra) {
        right: 126px;
      }
    }
  }

  &__pswp.pswp--zoomed-in .pswp__button {
    opacity: 0;
    pointer-events: none;
  }

  &__pswp.pswp--one-image .pswp__button {
    &--arrow {
      display: none;
    }
  }

  &__pswp .pswp__dynamic-caption {
    @include fontCurve("caption");
    color: $baseColor;
    overflow: auto;
    transition: opacity $baseTransitionAnimationSpeed;

    &--below,
    &--mobile {
      max-width: initial;
      max-height: calc(50vh - 44px - 16px - 8px);
      padding-top: 16px;
      padding-bottom: 16px;

      @include mq($from: small) {
        max-height: 33.333vh;
      }

      @include mq($from: medium) {
        padding-top: spaceCurveValue("tiny");
        padding-bottom: spaceCurveValue("medium");
      }

      @include mq($from: medium) {
        padding-top: spaceCurveValue("tiny", "medium");
        padding-bottom: spaceCurveValue("medium", "medium");
      }

      @include mq($from: large) {
        padding-top: spaceCurveValue("tiny", "large");
        padding-bottom: spaceCurveValue("medium", "large");
      }
    }

    &--mobile {
      @include spaceCurve("padding-left", "tiny");
      @include spaceCurve("padding-right", "tiny");
      background: $colorWhite60op;
    }
  }

  &__pswp .pswp__caption-wrapper {
    display: flex;
    flex-direction: column;
  }

  &__pswp .pswp__heading-wrapper {
    display: flow-root;
  }

  &__pswp .pswp__caption-counter {
    float: left;
    color: $colorSecondary60;

    &:not(:empty) {
      margin-right: space("xsmall");
    }
  }

  &__pswp .pswp__caption-counter,
  &__pswp .pswp__caption-heading {
    @include font("heavy");
  }

  &__pswp .pswp__caption-copyright {
    @include font;
    @include fontSize("femto");
    color: $colorGrey80;

    &:not(:empty) {
      margin-top: space("xxsmall");
    }
  }
}
